import React from "react";
import "./button.css";
const ViewPublicProfile = () => {
  return (
    <div className="">
      <a href="#">
        <button className="w-full mr-[45px] md:w-full md:mr-[75px] lg:mr-0  button-hero flex items-center justify-between bg-signupinputcolor text-sm lg:text-18 font-semibold px-3 py-2 md:px-4 md:py-2 rounded-full lg:px-10 lg:py-3">
          View Public Profile
        </button>
      </a>
    </div>
  );
};

export default ViewPublicProfile;
